export default function () {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function (Didomi) {
    const preferencesDidomi = document.querySelector('#preferencesDidomi');

    if (preferencesDidomi && Didomi.isRegulationApplied('gdpr')) {
      console.log('Didomi: gdpr apply');
      preferencesDidomi.classList.remove('hidden');
    }
  });
}
